<template>
  <v-container>
    <v-card class="rounded-t-lg">
      <v-card-title class="title style-color-main-gray">
        <span>Список выданных прав</span>
        <v-spacer></v-spacer>
        <v-btn @click="openCreateDialog" color="secondary" text>
          <v-icon>add</v-icon>
        </v-btn>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
                @click="reloadData()"
                class="mr-2"
                medium
                v-on="on"
            >
              update
            </v-icon>
          </template>
          <span>Обновить данные</span>
        </v-tooltip>
      </v-card-title>

      <v-data-table
          :headers="headers"
          :items="getItems"
          :loading="isLoading"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.size"
          :options.sync="options"
          :server-items-length="getCount"
          :footer-props="{'items-per-page-options':[25,50,100]}"
          class="elevation-2 rounded-b-lg rounded-t-0">
        >
        <template v-slot:item.event="{ item }">
          {{ item.event.name }}
        </template>
        <template v-slot:item.btn="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  @click="openDeleteDialog(item)"
                  medium
                  v-on="on"
              >
                delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <EditDialog
        v-if="dialog_add_edit"
        :opened="dialog_add_edit"
        :docs_data="docs_data"
        @close="closeEditDialog"
    ></EditDialog>
    <ApplyDialog
        v-if="dialog_delete"
        :opened="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить ?`"
        @close="closeDeleteDialog"
    ></ApplyDialog>
  </v-container>
</template>

<script>
import {generateListUidToName} from "@/helper/uidToName";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import UserDataMixin from '@/mixins/UserDataMixin'
import urls from '@/urls/helper.js'
import Form from "./components/EditDialog.vue"
import {loadData, makeGetRequest} from "@/helper/requests";
import {clearUserAuth} from "@/helper";
import {mapActions, mapGetters, mapMutations} from "vuex";
import store from "@/store";
import ApplyDialog from "@/modules/templates/ApplyDialog.vue";
import EditDialog from "@/modules/recording/page/admin/permission/components/EditDialog.vue";

export default {
  name: "List",
  mixins: [
    PaginatedDataMapperMixin
  ],
  components: {
    ApplyDialog,
    EditDialog
  },
  props: {},
  data() {
    return {
      dialog_add_edit: false,
      dialog_delete: false,
      edit_status: undefined,
      docs_data: undefined,
      headers: [
        {text: 'Пользователь', sortable: false, align: 'left', value: 'fio',},
        {text: 'Событие', sortable: false, align: 'left', value: 'event',},
        {text: 'Действия', sortable: false, align: 'right', value: 'btn'},
      ],
    }
  },
  computed: {
    ...mapGetters({
      getItems: 'permission/getRole',
      getCount: 'permission/getRoleCount',
      isLoading: 'permission/isLoadingRole',
      getCurrentUrl: 'permission/getCurrentUrl'
    }),
  },
  methods: {
    ...mapActions({
      loadList: 'permission/loadRoleList',
      deleteRole: 'permission/deleteRole',
    }),
    ...mapMutations({
      addUpdateRole: 'permission/SET_ROLE'
    }),
    openCreateDialog() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.docs_data = undefined
    },
    openEditDialog(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.docs_data = item
    },
    openDeleteDialog(item) {
      this.dialog_delete = true
      this.docs_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.dialog_delete = false
      this.docs_data = undefined
    },
    closeDeleteDialog(event) {
      if (event) {
        this.deleteRole({
          id: this.docs_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
      this.dialog_delete = false
      this.docs_data = undefined
    },
    loadData(url = undefined) {
      this.loadList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
          generateListUidToName(data['results'], "user", "fio", (data, url) => {
            this.addUpdateRole(data);
          })
        }
      })
    },
    reloadData() {
      this.clearSearchData()
    },

  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>
</style>
